import CTA5 from './CTA5'
export default CTA5
